import React from 'react'

import { Layout } from 'antd'

import './index.less'

const { Footer } = Layout;

export default class commonFooter extends React.Component {
  render () {

    return (
      <Footer style={{ textAlign: 'center' }}>
        3D Smile © 2017 
      </Footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/index.jsx